/**
 * DropdownLayer
 */

import Config from './Config';
import Util from './Util';

class DropdownLayer {
  private $node: any;

  private name: string;

  private textValue: string;

  private listValue: string;

  private $_node: any;

  private $callback: any;

  private dropDownLayer: string;

  constructor($node: any, data: any, name: string = 'board', className?: string) {
    this.$node = $node;
    this.name = name;

    // current text value
    this.textValue = '';

    // current category key(id)
    this.listValue = '';
    this.$_node = jQuery(this.template(data, className));
    this.$node.append(this.$_node);
    this.$callback = $.Callbacks();

    this.dropDownLayer = '#' + this.name + ' .ui-dropdown-community';

    this.addEvent();
  }

  private toggleSelectLayer(parent: any) {
    const $p = parent;
    const dropdownLayer = this.dropDownLayer;

    if ($p.hasClass('is-active')) {
      $p.removeClass('is-active');
    } else {
      // select메뉴가 복수일 경우 모두 제거
      jQuery(dropdownLayer).removeClass('is-active');
      $p.addClass('is-active');
    }
  }

  private addEvent() {
    const dropdownLayer = this.dropDownLayer;
    const dropdownLayerTitle = dropdownLayer + ' .select';
    const dropdownLayerList = dropdownLayer + ' .option';

    // 셀렉트메뉴 레이어: title 클릭 시 리스트 활성화/비활성화
    jQuery('body').on('click', dropdownLayerTitle, e => {
      if (jQuery(dropdownLayerTitle).hasClass('disabled')) {
        return;
      }

      const $parent = jQuery(dropdownLayerTitle).parent(dropdownLayer);

      this.toggleSelectLayer($parent);
    });

    // 셀렉트메뉴 레이어: list 선택 시 title 변경
    jQuery('body').on('click', dropdownLayerList, e => {
      const $selectedDropdown = jQuery(dropdownLayerList).parent(dropdownLayer);
      const $eventTartget = jQuery(e.target);

      if ($eventTartget.hasClass('option')) {
        return;
      }

      this.textValue = $eventTartget.text();
      this.listValue = $eventTartget.data('value');

      this.toggleSelectLayer($selectedDropdown);

      // 타이틀 영역 텍스트 변경
      jQuery(dropdownLayerList)
        .siblings(dropdownLayerTitle)
        .find('span')
        .not('.fr-marker')
        .text(this.textValue);
      jQuery(dropdownLayerList)
        .find('li')
        .removeClass('is-selected');
      $eventTartget.addClass('is-selected');

      this.$callback.fire('' + this.listValue);
    });

    // mobile
    jQuery('#' + this.name).on('change', 'select', evt => {
      const $eventTartget = jQuery(evt.target);
      this.listValue = $eventTartget.val() as string;
      this.$callback.fire('' + this.listValue);
    });

    // if document is clicked, hide modalLayer;
    jQuery('body').on('click', evt => {
      const container = jQuery(this.dropDownLayer);
      if (!container.is(evt.target) && container.has(evt.target).length === 0) {
        const $parent = jQuery(dropdownLayerTitle).parent(dropdownLayer);
        $parent.removeClass('is-active');
      }
    });
  }

  public removeEvent() {
    const dropdownLayer = this.dropDownLayer;
    const dropdownLayerTitle = dropdownLayer + ' .select';
    const dropdownLayerList = dropdownLayer + ' .option';

    jQuery('body').off('click', dropdownLayerList);
    jQuery('body').off('click', dropdownLayerTitle);
    jQuery('body').off('click', this.dropDownLayer);
  }

  public addChange(callback: any) {
    this.$callback.add(callback);
  }

  public getNode() {
    return this.$_node;
  }

  public setValue(val = '') {
    if (!val) {
      return;
    }

    const valueNode = jQuery(this.dropDownLayer)
      .find('.option')
      .find(`[data-value="${val}"]`);

    if (valueNode.length) {
      const text = jQuery(this.dropDownLayer)
        .find('.option')
        .find(`[data-value="${val}"]`)
        .text();
      jQuery(this.dropDownLayer)
        .find('.select')
        .find('span')
        .not('.fr-marker')
        .text(text || '');
      this.textValue = text;
      this.listValue = val;
      // mobile
      if (val !== '') {
        jQuery('#' + this.name)
          .find('select')
          .val(val);
      }
    }
  }

  public setTextValue(val = '') {
    if (!val) {
      return;
    }

    const valueNode = jQuery(this.dropDownLayer)
      .find('.option')
      .find(`[data-textvalue="${val}"]`);

    if (valueNode.length) {
      const text = jQuery(this.dropDownLayer)
        .find('.option')
        .find(`[data-textvalue="${val}"]`)
        .text();
      jQuery(this.dropDownLayer)
        .find('.select')
        .find('span')
        .not('.fr-marker')
        .text(text || '');
      this.textValue = text;
      this.listValue = valueNode.attr('data-value');

      // mobile
      if (this.listValue !== '') {
        jQuery('#' + this.name)
          .find('select')
          .val(this.listValue);
      }
    }
  }

  public getValue() {
    return this.listValue;
  }

  public getTextValue() {
    return this.textValue;
  }

  private template(_data: any, className: string = 'board-category') {
    const mobileList = Util.Tmpl.iterate({
      data: _data,
      template: (_v: any) => `<option data-textvalue="${_v.value}" value="${_v.key}">${_v.value}</option>`
    });

    const pcList = Util.Tmpl.iterate({
      data: _data,
      template: (_v: any) => `<li class="ui-dropdown-custom_items" data-textvalue="${_v.value}" data-value="${_v.key}">${_v.value}</li>`
    });

    return `<div id="${this.name}" class="ui-dropdown-wrap ${className}">
				<!-- mobile -->
				<div class="ui-dropdown ui-dropdown-elements">
					<div class="select">
						<select name="${className}">
							${mobileList}
						</select>
						<i class="fe-icon-arrow_down"></i>
					</div>
				</div>

				<!-- pc -->
				<div class="ui-dropdown ui-dropdown-community">
					<div class="select">
						<span>${Config.L10N.choose}</span>
						<i class="fe-icon-arrow_down"></i>
					</div>
					<ul class="option">
						${pcList}
					</ul>
				</div>
			</div>`;
  }
}

export default DropdownLayer;
